<template>
  <v-skeleton-loader :loading="loading" transition="scale-transition" type="table-tbody">
    <v-card outlined class="pa-4">
      <v-card-text class="pa-0 pb-3">
        <div class="title font-weight-light">Monthly MRA Scores</div>
      </v-card-text>
      <line-chart 
        :data="dataCollection" 
        :options="options"
        :styles="chartStyles"
        :chart="'mra'"
      ></line-chart>
    </v-card>
  </v-skeleton-loader>
</template>

<script>
import axios from 'axios';
import LineChart from '../charts/LineChart';

export default {
  components: {
    LineChart,
  },
  props: [
    'organization', 
    'insurance', 
    'group', 
    'providers', 
    'locations', 
    'startDate',
    'reportData'
  ],
  data() {
    return {
      cancelSource: null,
      loading: true,
      dataCollection: null,
      chartMonths: [],
      chartValues: [],
      lineColor: '#e2175b',
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "Months",
              },
              gridLines: {
                color: "rgba(61, 97, 133, 0.25)",
                display: true,
                drawBorder: false,
                drawTicks: false
              },
              ticks: {
                  padding: 10
              }
            },
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "MRA",
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },
      },
    };
  },
  mounted() {
    // this.getData();
  },
  methods: {
    // Get  all patients
    async getData() {
      this.loading = true;
      const org = this.organization;
      const { group } = this;
      const pro = this.providers;
      const loc = this.locations;
      const ins = this.insurance;
      const start = this.startDate;
      let provNum = [];
      let locAddress = [];
      let url;
      const { cancel } = this;

      if (pro.length > 0) {
        pro.forEach((prov) => {
          if (provNum.indexOf(prov.Center_PCP_Number) === -1) {
            provNum.push(prov.Center_PCP_Number);
          }
        });
      } else {
        provNum = [];
      }

      if (loc.length > 0) {
        loc.forEach((loca) => {
          if (locAddress.indexOf(loca.Center_Location) === -1) {
            locAddress.push(loca.Center_Location);
          }
        });
      } else {
        locAddress = [];
      }

      // Check for pending request and if so cancel old one for new incoming
      this.cancelSearch();
      // Set the CancelToken
      this.cancelSource = axios.CancelToken.source();

      url = `/api/coding/scorecard/mra/group=${group}/provider=${provNum}/location=${locAddress}/${ins}/${start}`;
      const response = axios.get(url, { cancelToken: this.cancelSource.token }).then((response) => {
        this.loading = false;
        this.cancelSource = null;
        this.chartMonths = [];
        this.chartValues = [];

        response.data.forEach(item => {
          this.chartMonths.push(item.month);
          this.chartValues.push(item.mra.toFixed(2));
        })
      });
    },
    chartData() {
      this.dataCollection = {
        labels: this.chartMonths,
        datasets: [
          {
            label: "MRA",
            borderColor: this.lineColor,
            pointBackgroundColor: this.lineColor,
            borderWidth: 3,
            data: this.chartValues,
          },
        ],
      };
      this.dataCollection;
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
  },
  computed: {
    chartStyles() {
      return {
        height: '100%'
      }
    }
  },
  watch: {
    async reportData() {
      if(this.reportData.breakdown) {
        this.getData();
      }
    },
    async chartValues() {
      this.chartData();
    },
  },
};
</script>

<style></style>
